import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { AdjustmentTargetEvaluation } from "./adjustment-target-evaluation";
import { CycleData } from "../cycle-data/cycle-data";
import { AdjustmentDosageTimeRange } from "./adjustment-dosage-time-range";

@staticImplements<ResponseModelInterfaceStatic>()
export class Adjustment
{
    public constructor(
        public score: number,
        public targetEvaluations: AdjustmentTargetEvaluation[],
        public dosageHistory: AdjustmentDosageTimeRange[],
        public cycleData: CycleData[],
    )
    {
    }

    public get lastHistoryItem(): AdjustmentDosageTimeRange|null
    {
        return this.dosageHistory[this.dosageHistory.length - 1] ?? null;
    }

    public static makeFromXml(elem: XmlElementWrapper): Adjustment
    {
        const score = elem.firstChildByTag("score").valueAsNumber();
        const targetEvaluations: AdjustmentTargetEvaluation[] = [];

        elem.firstChildByTagOrNull("targetEvaluations")?.forEachChildWithTag("targetEvaluation", (subElem) => {
            targetEvaluations.push(AdjustmentTargetEvaluation.makeFromXml(subElem));
        });

        const dosageHistory = elem
            .firstChildByTag("dosageHistory")
            .mapForEachChildTag("dosageTimeRange", (subElem) => AdjustmentDosageTimeRange.makeFromXml(subElem));

        const cycleData = elem
            .firstChildByTag("cycleDatas")
            .mapForEachChildTag("cycleData", (subElem) => CycleData.makeFromXml(subElem));

        return new this(
            score,
            targetEvaluations,
            dosageHistory,
            cycleData,
        );
    }
}
